import { apiService } from "../apiService";
import leadURLConfig from "../../../config/login/leadURLConfig";
import { jwtToken } from "../../types/genericTypes";
import LoginService from "../login/loginService";
import { apiAService } from "../apiService";

let pToken: jwtToken | null = LoginService.pToken,
	userID = pToken ? pToken.username : null;

//after redirect reinstate pToken with parsed jwt token
const pTokenCheck = (paramChk?: keyof jwtToken) => {
	if (!pToken) {
		pToken = LoginService.pToken;
		userID = pToken ? pToken.username : null;
	}
	return paramChk && pToken ? pToken[paramChk] : pToken;
};
// Add fund Equity-Limits - rms sublimits
export const saveLeadInfo_v1 = (callback: CallableFunction, reqBody: {}) => {
	if (pTokenCheck("accType") !== "CO") {
		apiService(
			{
				url: leadURLConfig.saveLeadInfoV1,
				method: "POST",
				authType: "bearer",

				body: reqBody
			},
			callback
		);
	}
};
export const getLeadMasterDetails = async (pageId: string) => {
	return await apiAService({
	  url: leadURLConfig.getLeadMasterDetails + pageId,
	  method: "GET",
	  authType: "bearer",
	});
  };
